import vtkCornerAnnotation from './CornerAnnotation';
import vtkFPSMonitor from './FPSMonitor';
import vtkIcons from './Icons';
import vtkSlider from './Slider';
import vtkVolumeController from './VolumeController';

export default {
  vtkCornerAnnotation,
  vtkFPSMonitor,
  vtkIcons,
  vtkSlider,
  vtkVolumeController,
};
